/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
  bearer: string;
};
type HookTuple = [
  response: vp.EditSignerResponse,
  EditSigner: (params: vp.EditSignerRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const userPostEditSigner: ApiHook = ({ api, bearer }) => {
  const [shouldEditSigner, setShouldEditSigner] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [params, setParams] = useState<vp.EditSignerRequest>({
    AuthorizedFullLegalName: '',
    AuthorizedEmailAddress: '',
    AuthorizedOccupation: '',
    AuthorizedDOB: '',
  });
  const [response, setResponse] = useState<vp.EditSignerResponse>({
    Success: false,
    ErrorMessage: '',
    Message: '',
  });

  useEffect(() => {
    if (!shouldEditSigner) return () => {};

    const EditSigner = async () => {
      setDataFetchingInfo(true, 'Editing Signer', 'fullScreen');
      const res = await api.postEditSigner(params, bearer, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldEditSigner) void EditSigner();
    setShouldEditSigner(false);
    return () => {
      source.cancel();
    };
  }, [shouldEditSigner]);

  return [
    response,
    (_params: vp.EditSignerRequest) => {
      setParams(_params);
      setShouldEditSigner(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Message: '',
      });
      setShouldEditSigner(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(userPostEditSigner);
